import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import AppBoxCollection from '../components/App-box-collection';
import {fetchPendingIfNeeded, removePendingInMarketApp} from '../actions/apps-by-type';
import _ from 'lodash';
import {objectToQueryString} from '../services/utils';
import {historyPush} from '../services/history';
import {openCategory} from '../actions/categories';

class PendingApps extends React.Component {

  constructor(props) {
    super(props);
    this.handleRemovePending = this.handleRemovePending.bind(this);
    this.getPendingData = this.getPendingData.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(fetchPendingIfNeeded());
  }

  getPendingData(app) {
    return _.find(this.props.pendingInMarket, i => i.guid === app.appDefinitionId);
  }

  handleRemovePending(app) {
    return ev => {
      ev.preventDefault();
      this.props.dispatch(removePendingInMarketApp(app));
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.pendingInMarket.length === 0) {
      historyPush(`/${objectToQueryString(this.props.query)}`);
    }
  }

  componentWillMount() {
    this.props.dispatch(openCategory('pending-apps'));
  }

  render() {
    const apps = this.props.pending;

    return (
      <div className="short-header-page secondary-inner-page">

        <div className="section section-pad section-vertical-pad">
          <h1 className="title">
            <span className="typography_h1">
              <FormattedMessage id="category.pending.name"/>
            </span>
          </h1>
          <h2 className="sub-title">
            <span className="typography_t1">
              <FormattedMessage id="category.pending.headerNew"/>
            </span>
          </h2>
        </div>

        {this.props.loading ?
          <div className="circle-loader"></div> : ''}

        <div className="app-box-grid section section-pad-left">
          {apps.map((app, i) =>
            <div className="col col-1-4" key={app.slug}>
              <AppBoxCollection
                app={app}
                reviews={this.props.reviews}
                biPosition={i + 1}
                onRemovePending={this.handleRemovePending}
                pendingAppData={this.getPendingData(app)}
                />
            </div>
          )}
        </div>

      </div>
    );
  }
}

PendingApps.propTypes = {
  pending: PropTypes.array.isRequired,
  pendingInMarket: PropTypes.array.isRequired,
  reviews: PropTypes.object,
  params: PropTypes.object,
  loading: PropTypes.bool,
  dispatch: PropTypes.func,
  query: PropTypes.object
};


function mapStateToProps(state) {
  const pending = state.appsByType.pending.items;
  const pendingInMarket = state.appsByType.pendingInMarket.items;
  const loading = state.appsByType.pending.isFetching;
  const reviews = state.reviews.all;
  const query = state.mode.query;

  return {pending, pendingInMarket, reviews, loading, query};
}

export default connect(mapStateToProps)(PendingApps);



// WEBPACK FOOTER //
// ./containers/Pending-apps.js